import React from 'react';
import { useEffect, useState } from "react";
import Select from 'react-select';
import { getAllData, postUsersData, patchUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import Switch from 'react-switch';
import { alphaNumericspace, formatDate, formatJsonDateToSQL, formatTimeHourMinute, } from '../../commonClass/CommonValidation';
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ConfirmationModal } from '../../../customControl/ConfirmationModal';
import CustomTable from '../../../customControl/CustomTable';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import CommonFilter from '../../../customControl/CommonFilter';



const Role = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState({});
    const [buttonaddeditText, setButtonAddEditText] = useState("Add");
    const [editdisabled, setEditDisabled] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [roledata, setRoleData] = useState([]);
    const [useredit, setUserEdit] = useState(true);
    const [useradd, setUserAdd] = useState(true);
    const [userexport, setUserExport] = useState(true);
    const user = useSelector((store) => store.userstatus.tba);
    const [form, setForm] = useState({
        DepartmentId: 0,
        RoleId: 0,
        RoleName: '',
        TurnaroundTime: null,
        IsActive: false,
        UserId: 0,
        UserType: 0
    });
    const [dropDownlist, setDropDownList] = useState([])
    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);
    const [filteritems, setFilterItems] = useState([]);

    const handleisActive = (e) => {
        if (buttonaddeditText === 'Add') {
            form.IsActive = !form.IsActive
            setFormErrors({});
        }
        else {
            setModalShow(true);
        }
    }

    const handleConfirmation = (e) => {
        if (e === true) {
            form.IsActive = !form?.IsActive
            setEditDisabled(true);
            setFormErrors({});
        }
        setModalShow(false);
    }

    const columns = [
        {
            name: 'Department Name',
            key: 'DepartmentName',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (list) => list?.DepartmentName
        },
        {
            name: 'Role Name',
            key: 'RoleName',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (list) => list?.RoleName
        },
        {
            name: 'TAT',
            key: 'TurnaroundTimeformat',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (list) => list?.TurnaroundTimeformat,
            format: (list) => list?.TurnaroundTimeformat,
        },
        {
            name: 'Status',
            key: 'Active',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (list) => list?.Active
        },
        {
            name: 'Created Date',
            sortable: true,
            reorder: true,
            float: "left",
            selector: (list) => new Date(list?.CreatedOn),
            format: (list) => list?.CreatedDate,
        },
        {
            name: 'Edit',
            selector: (list) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' disabled={!useredit}><i className="fa-regular fa-pen-to-square" onClick={() => handleEditView(list, 'edit')}></i></button>
        },
        {
            name: 'View',
            selector: (list) => <button type='button' className='border-0 p-0 bg-transparent set_disableclr' onClick={() => handleEditView(list, 'view')}><i className="fa-regular fa-eye"></i></button>
        }
    ];

    //#endregion

    useEffect(() => {
        dispatch(loaderActions.start());
        getRolelist();
        getroleoptions();
    }, []);

    useEffect(() => {
        if (window.location.pathname !== '/dashboard') {
            let pagelink = user?.find(x => {
                if (x.PageLink === window.location.pathname)
                    return x.MenuId
            });
            let mid = user?.find(x => x.MenuId === pagelink.MenuId);
            if (mid?.URightView === false && mid?.URightView !== undefined) {
                navigate('/dashboard');
            }
            user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
                setUserAdd(obj.URightAdd);
                setUserEdit(obj.URightEdit);
                setUserExport(obj.URightExport);

            });
        }
    }, [user])
    //#endregion

    const getRolelist = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            await getAllData('/auth/v1/getallrole?UserType=' + form.UserType).then((roledata) => {
                roledata?.data?.map((obj) => {
                    obj.Active = obj.IsActive ? 'Active' : 'InActive'
                    obj.CreatedDate = formatDate(obj?.CreatedOn)
                    obj.TurnaroundTimeformat = formatTimeHourMinute(obj?.TurnaroundTime)
                    return obj;
                })
                setRoleData(roledata.data);
                setFilterItems(roledata.data);
                dispatch(loaderActions.end());
            });
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }

    const getroleoptions = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const list = await getAllData('/auth/v1/getroleoptions?UserType=' + form.UserType)
            if (list?.status) {
                const Department = list?.data?.map((obj) => ({
                    label: obj?.DepartmentName,
                    value: obj?.DepartmentId,
                }));
                setDropDownList(Department);
            }
            else {
                setDropDownList([]);
            }
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const handleEditView = (data, type) => {
        setFormErrors({});
        setEditDisabled(false);
        setSerachDisable(true);
        setForm((form) => ({
            ...form,
            DepartmentId: data?.DepartmentId,
            RoleId: data?.RoleId,
            RoleName: data?.RoleName,
            TurnaroundTime: data?.TurnaroundTime,
            IsActive: data?.IsActive,
        }))
        setButtonAddEditText("Update");
        if (type === 'edit') {
            setDisabled(false);
        }
        else {
            setDisabled(true);
        }
    }

    const validateData = () => {
        let status = true;
        const error = {}
        if (form?.DepartmentId === 0 || form?.DepartmentId === null) {
            error.DepartmentId = "Kindly select Department.";
            status = false;
        }
        if (form?.RoleName?.trim()?.length === 0 && form?.DepartmentId > 0) {
            error.RoleName = "Please Provide Role.";
            status = false;
        }

        if (Object.keys(error).length > 0) {
            let id = Object.keys(error)[0];
            let doc = document.getElementById(id);
            if (doc !== null)
                doc.focus();
        }

        setFormErrors(error);
        return status;
    }

    const handleSubmitData = async () => {
        if (validateData()) {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let user = GetLocalStorage();
                form.UserId = user?.userMasterID
                const RoleData = buttonaddeditText === 'Add' ? await postUsersData('/auth/v1/insertrole', form)
                    : await patchUsersData('/auth/v1/updaterole', form)
                const status = RoleData.status;
                if (!RoleData.status && !RoleData.data) {
                    dispatch({ type: 'ALERTING', message: RoleData.message });
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
                if (status) {
                    dispatch({ type: 'ALERTING', message: RoleData.message });
                    handleClearClick();
                }
                else {
                    dispatch({ type: 'ALERTING', message: RoleData.message })
                    setDisabled(false);
                    setEditDisabled(true);
                    return;
                }
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
    }

    const onChange = (name, val) => {
        setForm((form) => ({ ...form, [name]: val }))
        setEditDisabled(true);
        setFormErrors({});
    }

    const handleClearClick = () => {
        setButtonAddEditText('Add');
        setDisabled(false);
        setFormErrors({});
        setForm((form) => ({
            ...form,
            DepartmentId: 0,
            RoleId: 0,
            RoleName: '',
            TurnaroundTime: null,
            IsActive: false,
        }))
        getRolelist();
        setEditDisabled(true);
        setSerachDisable(false);
        setSerachBy('All');
        setSearchValue('');
    }
    //#endregion


    return (
        <form action="" >
            <div className="mb-1 row mx-1">
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <label htmlFor="DepartmentId" className="col-form-label required">Select Department</label>
                        </div>
                        <div className=" col-lg-8 col-md-12 col-sm-12">
                            <Select
                                inputId='DepartmentId'
                                name='DepartmentId'
                                className='dropdown select_dropdown'
                                options={dropDownlist}
                                value={dropDownlist?.filter((fil) => fil?.value === form?.DepartmentId)}
                                isSearchable={true}
                                closeMenuOnSelect={true}
                                placeholder='Select'
                                onChange={(e) => onChange('DepartmentId', (e?.value ? e?.value : 0))}
                                isClearable
                                isDisabled={disabled ? true : false}
                            />
                            {formErrors?.DepartmentId && <div className='text-danger text-start fs_14'>{formErrors?.DepartmentId}</div>}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <label htmlFor="RoleName" className="col-form-label required">Role Name</label>
                        </div>
                        <div className=" col-lg-8 col-md-12 col-sm-12">
                            <input className="form-control"
                                type="text"
                                id='RoleName'
                                name="RoleName"
                                value={form?.RoleName}
                                onChange={(e) => onChange("RoleName", alphaNumericspace(e?.target?.value))}
                                disabled={disabled || form?.DepartmentId === 0}
                                placeholder='Role Name'
                                maxLength={35}
                            />
                            {formErrors?.RoleName && <div className='text-danger text-start fs_14'>{formErrors?.RoleName}</div>}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <label htmlFor="inputPassword6" className="col-form-label">Select TAT</label>
                        </div>
                        <div className=" col-lg-8 col-md-12 col-sm-12">
                            <TimePicker
                                id='startTime'
                                className='form-control defo_border'
                                placeholder='--:--'
                                format='HH:mm'
                                value={form?.TurnaroundTime ? dayjs(form?.TurnaroundTime) : null}
                                needConfirm={false}
                                onChange={(e) => onChange('TurnaroundTime', e?.$d ? formatJsonDateToSQL(e?.$d) : null)}
                                disabled={disabled}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 col-sm-12">
                            <label htmlFor="inputPassword6" className="col-form-label">Active</label>
                        </div>
                        <div className="col-auto col-lg-6">
                            <Switch
                                onChange={handleisActive}
                                checked={form?.IsActive}
                                className="react-switch"
                                disabled={disabled ? true : false}
                            />
                        </div>
                        <ConfirmationModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            noconfirm={() => handleConfirmation(false)}
                            yesconfirm={() => handleConfirmation(true)}
                        />

                    </div>
                </div>
            </div>
            <div className="mt-3 d-flex justify-content-center">
                {useradd === false && buttonaddeditText === "Add" ?
                    <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleSubmitData} disabled={!useradd}>{buttonaddeditText}</button> :
                    <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleSubmitData} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>}
                <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
            </div>
            <CommonFilter
                columns={columns}
                filterList={filteritems}
                searchDisabled={serchdisable}
                getdata={getRolelist}
                setlistdata={setRoleData}
                searchvalue={searchvalue}
                setSearchValue={setSearchValue}
                searchby={searchby}
                setSerachBy={setSerachBy}
            />

            <CustomTable
                columns={columns}
                data={roledata}
                PdfExport={false}
                ExportToExcel={false}
                disabled={false}
            />
        </form>
    )
}

export default Role